// src/actions/review.js

import api from './lambda-api'
import moment from 'moment'
import config from '../config'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_REVIEW = "FETCH_REVIEW"
export const FETCH_REVIEW_REQUESTED = "FETCH_REVIEW_REQUESTED"
export const FETCH_REVIEW_STREAMING = "FETCH_REVIEW_STREAMING"
export const FETCH_REVIEW_COMPLETED = "FETCH_REVIEW_COMPLETED"
export const FETCH_REVIEW_FAILED = "FETCH_REVIEW_FAILED"

export function fetchReviewRequested() {
  return {
    type: FETCH_REVIEW_REQUESTED
  }
}

export function fetchReviewStreaming(results) {
  return {
    type: FETCH_REVIEW_STREAMING,
    results,
  }
}

function getReader(dispatch, res) {
  if (res.body) {
    const reader = res.body.getReader();
    const parseData = (input) => {
      const regex = /data:\s*/g;
      const data = input.replace(regex, "").replace(/\s/g, "");
      return data;
    };

    const processStream = () => {
      reader.read().then(({ done, value }) => {
        if (done) {
          dispatch(fetchReviewCompleted());
          return;
        }
        const text = new TextDecoder("utf-8").decode(value);
        dispatch(fetchReviewStreaming(parseData(text)));
        processStream();
      }).catch((error) => {
        console.error('読み取り中にエラーが発生しました:', error);
        reader.releaseLock();
      });
    };

    processStream()
  }
}

export function fetchReview(user_message) {
  return function(dispatch) {
    dispatch(fetchReviewRequested())
    return api.post(`/chatgpt_review`, user_message)
        .then((results)=> {
          getReader(dispatch, results)
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchReviewFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchReviewCompleted(results) {
  return {
    type: FETCH_REVIEW_COMPLETED,
    results,
  }
}

export function fetchReviewFailed(error) {
  return {
    type: FETCH_REVIEW_FAILED,
    error,
  }
}

export const CLEAR_REVIEW = "CLEAR_REVIEW"

export function clearReview() {
  return {
    type: CLEAR_REVIEW
  }
}

export const INITIALIZE_REVIEW = "INITIALIZE_REVIEW"

export function initReview() {
  return {
    type: INITIALIZE_REVIEW
  }
}

export const OPEN_REVIEW_PANEL = "OPEN_REVIEW_PANEL"

export function openReviewPanel() {
  return {
    type: OPEN_REVIEW_PANEL
  }
}

export const CLOSE_REVIEW_PANEL = "CLOSE_REVIEW_PANEL"
export function closeReviewPanel() {
  return {
    type: CLOSE_REVIEW_PANEL
  }
}



// WEBPACK FOOTER //
// ./src/actions/review.js